import React from "react";
import jsPDF from "jspdf";
import "jspdf-autotable";

export const ExportPdf = ({ Data, fileName }) => {

  const exportPDF = (Data, fileName) => {
    // console.log(Data)
    const unit = "pt";
    const size = "A4"; // Use A1, A2, A3 or A4
    const orientation = "landscape"; // portrait or landscape

    const marginLeft = 40;
    const doc = new jsPDF(orientation, unit, size);

    doc.setFontSize(15);

    let title = "Email Logs";
    let pdf_headers = [];
    let pdf_data = [];
    let content = {
      startY: 50,
      head: pdf_headers,
      body: pdf_data,
      styles: { "overflow": "linebreak", "cellWidth": "wrap" },
      pageBreak: "auto",
      pagesplit: true,
      tableWidth: "auto",
      showHead: "everyPage",
      showFoot: "everyPage",
      tableLineWidth: 0,
      tableLineColor: 200,
      margin: { "top": 30 },
    }

    if (Data && Data.length > 0) {
      title = Data[0].Type + " Email Logs";
      if (Data[0].Type === 'PRINCIPAL' || Data[0].Type === 'DIGEST' || Data[0].Type === 'DAILYEMAIL') {
        pdf_headers.push(["Email", "Posts Uid", "Sent Date", "Delivered", "Opened", "Clicked"])
        content['columnStyles'] = {
          1: { "halign": "left", "cellWidth": 'auto' }
        }
      } else {
        content['columnStyles'] = {
          2: { "halign": "left", "cellWidth": 'auto' },
          3: { "halign": "left", "cellWidth": 'auto' },
          4: { "halign": "left", "cellWidth": 'auto' },
          6: { "halign": "left", "cellWidth": 'auto' },
          7: { "halign": "left", "cellWidth": 'auto' },
          8: { "halign": "left", "cellWidth": 'auto' },
          9: { "halign": "left", "cellWidth": 'auto' },
          10: { "halign": "left", "cellWidth": 'auto' },
          11: { "halign": "left", "cellWidth": 'auto' }
        }
        pdf_headers.push(["UserId", "Name", "Email", "Sent Date", "Subject", "StudentId", "Student Name", "Absence Date", "Reason", "Delivered", "Opened", "Clicked"])
      }

      Data.forEach((item, index) => {
        if (item.Type === 'PRINCIPAL' || item.Type === 'DIGEST' || item.Type === 'DAILYEMAIL') {
          pdf_data.push([item.Email, item.postUid_List, item.SENT_DATE, item.Delivered, item.Opened, item.Clicked])
        } else {
          pdf_data.push([item.UserId, item.Name, item.Email, item.SENT_DATE, item.Subject, item.StudentId, item.Student_Name, item.Absence_Date, item.Reason, item.Delivered, item.Opened, item.Clicked])
        }
      })
    }
    doc.text(title, marginLeft, 40);
    doc.autoTable(content);
    doc.save(fileName + '.pdf');
  }
  return (
    <div>
      <button className="bg-dark export-btn" onClick={(e) => exportPDF(Data, fileName)}>PDF</button>
    </div>
  )
}



